import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { setUserData } from '../../store/userSlice';
import { toast } from 'react-toastify';

const ABOUT_MAX_LENGTH = 200;

function About() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();
  const userData = useSelector((state) => state.user.userData);

  const [about, setAbout] = useState(userData?.about || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setAbout(e.target.value.slice(0, ABOUT_MAX_LENGTH));
  };

  const handleSave = async () => {
    const text = about.trim();

    // Пустой текст — просто возвращаемся без запроса
    if (!text) {
      navigate(-1);
      return;
    }

    setIsSubmitting(true);
    try {
      await axiosPrivate.put('/users/about', { about: text });

      // Обновляем пользователя в Redux, чтобы ProfileEdit сразу показал новый текст
      dispatch(setUserData({ ...userData, about: text }));
      navigate(-1);
    } catch (error) {
      console.error('Ошибка сохранения текста "О себе":', error);
      toast.error('Не удалось сохранить текст');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full flex items-center justify-center flex-col">
      <div className="sticky top-0 left-0 right-0 w-full bg-[#021111] pt-[30px] pb-[32px] pr-[16px] pl-[16px] text-[18px] flex justify-between z-50">
        <span
          className="text-white"
          onClick={() => {
            navigate(-1);
          }}
        >
          Отмена
        </span>
        <span
          className={`${isSubmitting ? 'opacity-50' : 'text-[#A1F69E] cursor-pointer'}`}
          onClick={isSubmitting ? undefined : handleSave}
        >
          {isSubmitting ? 'Сохранение...' : 'Сохранить'}
        </span>
      </div>

      <div className="flex flex-col items-center w-full px-4 pb-[40px]">
        <h1 className="font-raleway font-semibold text-white text-[20px] text-center">
          Напишите пару слов о себе
        </h1>
        <h2 className="font-raleway font-light mt-2 text-white text-[16px] text-center">
          Этот текст отобразится в вашей анкете
        </h2>

        <div className="w-full mt-4 relative">
          <textarea
            name="about"
            id="about"
            value={about}
            onChange={handleChange}
            className="w-full h-[300px] resize-none overflow-y-auto [overflow-wrap:anywhere] bg-[#022424] rounded-lg p-4 pb-8 border border-[#233636] text-white placeholder:text-[#6B8A8A] focus:outline-none focus:ring-2 focus:ring-[#A1F69E] font-raleway text-[16px] leading-relaxed"
            placeholder="О себе"
            maxLength={ABOUT_MAX_LENGTH}
          />
          <span className="absolute bottom-[12px] right-[16px] text-[12px] font-raleway text-[#6B8A8A] pointer-events-none bg-[#022424] px-1 rounded">
            {about.length}/{ABOUT_MAX_LENGTH}
          </span>
        </div>
      </div>
    </div>
  );
}

export default About;
